export const SEARCH_WORD = 'word/SEARCH_WORD'
export const FETCH_PROFILE_SUCCESS = 'word/FETCH_PROFILE_SUCCESS'
export const FETCH_PROFILE_FAILURE = 'word/FETCH_PROFILE_FAILURE'
